import React from 'react';
import Layout from '../components/shared/Layout';
import Header from '../components/shared/Header';
import Sponsor from '../components/shared/Sponsor';
import SponsorsDetail from '../components/sponsors/SponsorsDetail';

const Sponsors = () => (
    <Layout title="Our Sponsors">
        <Header title="Our Sponsors" page="Sponsors"/>
        <SponsorsDetail />
        <Sponsor />
    </Layout>
)

export default Sponsors;